var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgK1Satisfied(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 9a29 29 0 100 58 29 29 0 000-58zm0 54a25 25 0 110-49.999A25 25 0 0138 63zm14-14.86A2 2 0 0152 51a19.72 19.72 0 01-28 0 2 2 0 112.82-2.83 15.76 15.76 0 0022.28 0 2 2 0 012.9-.03zM44.5 31a4 4 0 118 0 4 4 0 01-8 0zm-21 0a4 4 0 118 0 4 4 0 01-8 0z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/K1_Satisfied.5fc9378a.svg";
export { SvgK1Satisfied as ReactComponent };